import styled from 'styled-components';

export const Log = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.black};
  margin: 6px 0;
  padding-bottom: 6px;
  cursor: pointer;

/* fill with dashed line between date and price(flex item) */
border-bottom: 1px dashed ${({ theme }) => theme.colors.border.grey};

.date{
    
}

  .price{
    font-weight: 700;
  }
`;

export const HistoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 20px 0 50px 0;
`;